import { ChannelWebglSettingsConverter } from "./channel-webgl-settings-converter";
import { getItemByField } from "../../../../../../../web-graphics";

export class RhythmChannelWebglSettingsConverter extends ChannelWebglSettingsConverter {
  constructor(commonSettings, configurationConverter) {
    super(commonSettings, configurationConverter);
  }

  convert(settings) {
    let settingsCopy = super.convert(settings);
    if (settingsCopy.conversionSettings?.type == "rhythm") {
      let id_sourceChannel = settingsCopy.conversionSettings.id_sourceChannel;
      let commonDataSource = getItemByField("id", settings.id_dataSource, this.commonSettings.data.sources);
      let sourceChannelSettings = getItemByField("id", id_sourceChannel, commonDataSource.channels);
      settingsCopy.conversionSettings.sourceChannel = sourceChannelSettings.copy();
    }
    return settingsCopy;
  }
}
